<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="serverError === null">
  <div class="form-group">
    <div class="form-check">
      <input class="form-check-input" type="checkbox"
             [(ngModel)]="autoLocationCheckInEventParticipantsSubList"
             name="autoLocationCheckInEventParticipantsSubList"
             id="autoLocationCheckInEventParticipantsSubList">
      <label class="form-check-label"
             for="autoLocationCheckInEventParticipantsSubList">
        Automatically check customers into the facility when checking them into the event
      </label>
      <small class="form-text text-muted">
        If this is not selected, a customer may be checked into the event without being checked into the facility. This means that their waiver will not be checked and their entry method will not be used (if entry is not included with the booking).
      </small>
    </div>
    <div class="form-check mt-2">
      <input class="form-check-input" type="checkbox"
             [(ngModel)]="showNonpaymentCancelledReservations"
             (ngModelChange)="onShowNonpaymentCancelledChange($event)"
             name="showNonpaymentCancelledReservations"
             id="showNonpaymentCancelledReservationsParticipants">
      <label class="form-check-label"
             for="showNonpaymentCancelledReservationsParticipants">
        Show reservations which were cancelled due to non-payment
      </label>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Filter participants by name, email"
             [(ngModel)]="search"
             (ngModelChange)="pageNumber = 1">
    </div>
    <div class="col-xl-7 col-12 mb-3 clearfix"></div>
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive"
       #participantTableWrapper>
    <table class="table table-12px" style="border-collapse: separate; border-spacing: 0;">

      <thead>
      <tr class="position-relative">
        <th scope="col" colspan="99" class="text-primary p-0" style="font-size: 16px;">
          <div style="padding-left: 12px; padding-right: 12px; position: sticky; left: 0;"
               #participantTableTitleContainer>
            <div class="d-inline-block" style="margin-top: 13px;">
              <span>Event Participants</span>
            </div>
            <div class="float-right" style="margin-top: 8px; margin-bottom: 8px;">
              <button *ngIf="!event.is_cancelled && !event.is_private && (event.roster_id === null)"
                      (click)="openCreateBookingModal()"
                      class="btn btn-sm btn-outline-primary mr-2"
                      style="font-size: 12px; line-height: 12px;">
                Create Booking
              </button>
              <button *ngIf="!event.is_cancelled && !event.is_private && (event.roster_id !== null)"
                      (click)="openAddToRosterModal()"
                      class="btn btn-sm btn-outline-primary mr-2"
                      style="font-size: 12px; line-height: 12px;">
                Add To Roster
              </button>
              <button *ngIf="!event.is_cancelled && !event.is_private && (event.roster_id !== null)"
                      (click)="openInviteToRosterModal()"
                      class="btn btn-sm btn-outline-primary mr-2"
                      style="font-size: 12px; line-height: 12px;">
                Invite To Roster
              </button>
              <a *ngIf="!event.is_cancelled && event.is_private"
                 href="#"
                 [routerLink]="'/events/scheduled/private-event/edit/' + event.event_id.toString() +'/event-details'"
                 class="btn btn-sm btn-outline-primary mr-2"
                 style="font-size: 12px; line-height: 12px;">
                Manage Private Event
              </a>
              <button *ngIf="!event.is_cancelled && event.is_private"
                      (click)="openAddParticipantToPrivateEventModal()"
                      class="btn btn-sm btn-outline-primary mr-2"
                      style="font-size: 12px; line-height: 12px;">
                Add Participant
              </button>
              <div ngbDropdown placement="bottom-right" container="body" class="d-inline-block">
                <button class="btn btn-sm btn-primary dropdown-toggle"
                        style="font-size: 12px; line-height: 12px;"
                        type="button"
                        id="participantsTableDropdown"
                        ngbDropdownToggle
                        aria-haspopup="true" aria-expanded="false">
                  More Options
                </button>
                <div ngbDropdownMenu
                     aria-labelledby="participantsTableDropdown" style="z-index: 10">
                  <a class="dropdown-item" href="#"
                     *ngIf="!event.is_cancelled && !event.is_private && (event.roster_id === null)"
                     (click)="openBulkUploadParticipantsModal();$event.preventDefault();">
                    Bulk Upload Participants
                  </a>
                  <a class="dropdown-item" href="#"
                     *ngIf="allCustomersAreLoaded()"
                     (click)="openExportAttendeeListModal();$event.preventDefault();">
                    Export Attendee List
                  </a>
                  <a class="dropdown-item disabled" href="#"
                     disabled
                     *ngIf="!allCustomersAreLoaded()"
                     (click)="$event.preventDefault();">
                    Loading...
                  </a>
                  <a class="dropdown-item" href="#"
                     [cdkCopyToClipboard]="getParticipantMailList(false)"
                     (click)="handleEmailsCopiedToClipboard();$event.preventDefault();">
                    Copy Participant Emails to Clipboard
                  </a>
                  <a class="dropdown-item" href="#"
                     [cdkCopyToClipboard]="getParticipantMailList(true)"
                     (click)="handleEmailsCopiedToClipboard();$event.preventDefault();">
                    Copy Emails (Include "Booked By")
                  </a>
                  <a class="dropdown-item" href="#"
                     *ngIf="!event.is_cancelled && event.climber_app_registration_url"
                     [cdkCopyToClipboard]="event.climber_app_registration_url"
                     (click)="handleRegistrationLinkCopiedToClipboard();$event.preventDefault();">
                    Copy Climber App Registration Link
                  </a>
                  <a class="dropdown-item" href="#"
                     *ngIf="!event.is_private && (event.event_type_schedule_type !== ScheduleType.rolling)"
                     (click)="openInviteToEventModal();$event.preventDefault();">
                    Invite Customer to Event
                  </a>
                  <a class="dropdown-item" href="#"
                     (click)="openInviteParticipantsToAnotherEventModal();$event.preventDefault();">
                    Invite Participants to Another Event
                  </a>
                </div>
              </div>
            </div>
          </div>
        </th>
      </tr>
      <tr>
        <th scope="col" class="reservation-checkbox-column"></th>
        <th scope="col" class="customer-name-column">Name</th>
        <th scope="col"></th>
        <th scope="col" *ngFor="let column of event.scheduled_events_columns" class="text-nowrap">
          {{ getScheduledEventsColumnHeaderName(column) }}
        </th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor="let res of filteredReservations()"
          [class.reservation-cancelled]="res.is_cancelled">

        <td class="table-12px-button-cell text-nowrap reservation-checkbox-column">
          <ng-container *ngIf="!event.is_private_event_request_form">
            <div *ngIf="!res.has_checked_in" class="d-inline-block"
                 container="body"
                 tooltipClass="check-in-slot-tooltip"
                 [ngbTooltip]="isPrivateEventOpenSlot(res) ? 'This is an empty reservation slot. Add a participant to the booking in order to check them in.' : null">
              <button [disabled]="res.checkInLoading || isPrivateEventOpenSlot(res)"
                      [class.disabled]="res.checkInLoading || isPrivateEventOpenSlot(res)"
                      class="btn btn-sm btn-outline-primary table-12px-button"
                      (click)="toggleReservationCheckIn(res)">
                Check In
              </button>
            </div>
            <button *ngIf="res.has_checked_in"
                    disabled
                    class="btn btn-sm btn-success table-12px-button disabled">
              Checked In
            </button>
          </ng-container>
          <ng-container *ngIf="event.is_private_event_request_form">
            <a *ngIf="!res.linked_private_event_id"
               routerLink="/events/scheduled/private-event/add-from-booking/{{ res.booking_id }}"
               class="btn btn-sm btn-outline-primary table-12px-button">
              Create Private Event
            </a>
            <a *ngIf="res.linked_private_event_first_part_id"
               routerLink="/events/scheduled/now/event/{{ res.linked_private_event_first_part_id }}"
               class="btn btn-sm btn-outline-primary table-12px-button">
              View Private Event
            </a>
          </ng-container>
        </td>

        <td *ngIf="res.customer_id" class="customer-name-column pb-0 text-nowrap" style="padding-top: 6px;">
          <div style="padding-top: 6px; padding-right: 2px;" class="d-inline-block">
            <!--
              The Bookings view (PRO-1338): full booking history including
              this event's — the default reservations view is upcoming-only.
            -->
            <a routerLink="/customers/{{ res.customer_id }}/reservations/bookings">
              {{ res.last_name }}, {{ res.first_name }}
              <ng-container *ngIf="res.preferred_name && (res.preferred_name !== res.first_name)">
                ({{ res.preferred_name }})
              </ng-container>
            </a>
          </div>
          <div class="d-inline-block text-muted" *ngIf="loadingCustomerProfileDetails[res.customer_id]">
            Loading...
          </div>
          <div class="d-inline-block" *ngIf="!loadingCustomerProfileDetails[res.customer_id]">
            <div *ngIf="customer[res.customer_id] && customer[res.customer_id].has_medical_notes"
                 ngbTooltip="Has medical notes"
                 class="d-inline">
              <app-medical-notes-icon [size]="0"></app-medical-notes-icon>
            </div>
            <div *ngIf="customerProfileDetails[res.customer_id] && customerProfileDetails[res.customer_id].has_alert_icon"
                 ngbTooltip="Has a profile alert"
                 class="d-inline">
              <app-alert-icon [size]="0"></app-alert-icon>
            </div>
            <div *ngIf="customerIdsWithoutParticipantAgreements.has(res.customer_id)"
                 ngbTooltip="Missing participant agreement ({{ event.participant_agreement_template_name }})"
                 class="d-inline">
              <app-alert-icon [size]="0" [colorHex]="missingDocumentAlertColor"></app-alert-icon>
            </div>
            <div *ngIf="customerIdToWaiverAlert.has(res.customer_id)"
                 [ngbTooltip]="customerIdToWaiverAlert.get(res.customer_id)"
                 class="d-inline">
              <app-alert-icon [size]="0" [colorHex]="missingDocumentAlertColor"></app-alert-icon>
            </div>
            <div *ngFor="let proficiency of getCustomerProficienciesForId(res.customer_id)"
                 class="d-inline"
                 [ngbTooltip]="proficiency.proficiency_name">
              <app-proficiency-icon [colorHex]="proficiency.proficiency_icon_color_hex"
                                    [iconInitials]="proficiency.proficiency_icon_initials"
                                    [size]="0">
              </app-proficiency-icon>
            </div>
            <div *ngFor="let icon of getCustomerMembershipIconsForId(res.customer_id)"
                 class="d-inline"
                 [ngbTooltip]="icon.icon_hover_text">
              <app-membership-icon [colorHex]="icon.icon_color_hex"
                                   [iconInitials]="icon.icon_initials"
                                   [size]="0"
                                   style="padding-right:1px">
              </app-membership-icon>
            </div>
          </div>
        </td>
        <td *ngIf="!res.customer_id" class="customer-name-column text-nowrap">
          <span *ngIf="res.birthday">
            {{ res.last_name }}, {{ res.first_name }}
          </span>
          <span *ngIf="!res.birthday" class="text-muted">
            None
          </span>
        </td>

        <td class="table-12px-button-cell text-nowrap">
          <div class="text-right" ngPreserveWhitespaces>
            <a *ngIf="res.booking_payment_url && !res.linked_private_event_id"
               [href]="res.booking_payment_url"
               target="_blank"
               rel="noopener"
               class="btn btn-sm btn-outline-primary table-12px-button"
               ngbTooltip="Click to take payment now (card reader included). Right-click to copy a link the payer can use without logging in."
               container="body"
               (click)="handleCompletePaymentClick(res, $event)">
              Complete Payment
            </a>
            <button *ngIf="!res.is_cancelled && !res.has_checked_in && !event.is_private && !event.is_private_event_request_form && (event.roster_id === null)"
                    class="btn btn-sm btn-outline-primary table-12px-button"
                    (click)="openRebookModal(res)">
              Rebook
            </button>
            <a *ngIf="!res.is_cancelled && !res.has_checked_in && !event.is_private"
               routerLink="booking/{{ res.booking_id }}/{{ res.reservation_id }}/manage-cancellation-and-refund"
               class="btn btn-sm btn-outline-danger table-12px-button">
              Cancel
            </a>
            <button *ngIf="res.has_checked_in"
                    [disabled]="res.checkInLoading"
                    [class.disabled]="res.checkInLoading"
                    class="btn btn-sm btn-outline-danger table-12px-button"
                    (click)="toggleReservationCheckIn(res)">
              Undo Check-In
            </button>
            <button class="btn btn-sm btn-outline-secondary table-12px-button"
                    (click)="openParticipantDetailsModal(res)">
              View
            </button>
          </div>
        </td>

        <td *ngFor="let column of event.scheduled_events_columns">

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.reservationEmail">
            <span *ngIf="res.email">{{ res.email }}</span>
            <span *ngIf="!res.email" class="text-muted">None Provided</span>
          </ng-container>

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.payment">
            <span *ngIf="(res.payment_fee_name) || (res.add_on_names.length > 0)">
              <span *ngIf="res.payment_status === ScheduledEventPaymentStatus.paymentPending" class="text-danger">
                <b>Incomplete</b>
              </span>
              <span *ngIf="res.payment_status === ScheduledEventPaymentStatus.depositPaid" class="text-warning text-nowrap">
                <b>Deposit Paid</b>
              </span>
              <span *ngIf="res.payment_status === ScheduledEventPaymentStatus.paymentComplete" class="text-success">
                Complete
              </span>
              <span *ngIf="res.payment_status === ScheduledEventPaymentStatus.partiallyRefunded" class="text-muted text-nowrap">
                Partially Refunded
              </span>
              <span *ngIf="res.payment_status === ScheduledEventPaymentStatus.refunded" class="text-muted">
                Refunded
              </span>
              <span *ngIf="res.payment_status === ScheduledEventPaymentStatus.cancelled" class="text-muted">
                Cancelled
              </span>
              <span class="text-nowrap">
                (Ref {{ res.payment_reference }})
              </span>
            </span>
            <span *ngIf="!((res.payment_fee_name) || (res.add_on_names.length > 0))" class="text-muted">
              N/A
            </span>
          </ng-container>

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.feeType">
            <span *ngIf="res.payment_fee_name">
              {{ capitalizeFirstLetter(res.payment_fee_name) }}
            </span>
            <span *ngIf="!res.payment_fee_name" class="text-muted text-nowrap">
              <ng-container *ngIf="res.is_staff_direct_booking">
                Staff Bypass
              </ng-container>
              <ng-container *ngIf="!res.is_staff_direct_booking">
                None
              </ng-container>
            </span>
          </ng-container>

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.addOns">
            <span *ngIf="res.add_on_names.length > 0" class="text-nowrap">
              <ng-container *ngFor="let add_on_name of (res.add_on_names_display || res.add_on_names)">
                {{ add_on_name }}<br>
              </ng-container>
            </span>
            <span *ngIf="res.add_on_names.length === 0" class="text-muted">None</span>
          </ng-container>

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.bookedBy">
            <span *ngIf="res.booked_by_id"
                [class.text-nowrap]="!allowNameWrapping(res.booked_by_first_name, res.booked_by_last_name)">
              <a routerLink="/customers/{{ res.booked_by_id }}">
                {{ res.booked_by_first_name }} {{ res.booked_by_last_name }}
              </a>
            </span>
            <span *ngIf="!res.booked_by_id" class="text-muted text-nowrap">
              Not Logged In
            </span>
          </ng-container>

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.hasEmergencyContact">
            <ng-container *ngIf="res.customer_id">
              <span *ngIf="loadingCustomerProfileDetails[res.customer_id]" class="text-muted">
                Loading...
              </span>
              <ng-container *ngIf="!loadingCustomerProfileDetails[res.customer_id]">
                <ng-container *ngIf="!customerNotFound[res.customer_id]">
                  <ng-container *appVar="customerProfileDetails[res.customer_id] as profDetails">
                    <span *ngIf="profDetails && profDetails.has_emergency_contact">
                      Yes
                    </span>
                    <span *ngIf="profDetails && !profDetails.has_emergency_contact" class="text-danger">
                      No
                    </span>
                  </ng-container>
                </ng-container>
                <span *ngIf="customerNotFound[res.customer_id]"
                    class="text-danger text-nowrap">
                  Customer Not Found
                </span>
              </ng-container>
            </ng-container>
            <span *ngIf="!res.customer_id && res.birthday" class="text-nowrap">
              <a href="#" *ngIf="!loadingUnlinkedReservation[res.reservation_id]"
                 (click)="openReviewUnlinkedReservationModal(res);$event.preventDefault();">
                Not Linked
              </a>
              <span class="text-muted" *ngIf="loadingUnlinkedReservation[res.reservation_id]">
                Loading...
              </span>
            </span>
          </ng-container>

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.medicalNotes">
            <ng-container *ngIf="res.customer_id">
              <span *ngIf="loadingCustomerProfileDetails[res.customer_id]" class="text-muted">
                Loading...
              </span>
              <ng-container *ngIf="!loadingCustomerProfileDetails[res.customer_id]">
                <ng-container *ngIf="!customerNotFound[res.customer_id]">
                  <ng-container *appVar="customerProfileDetails[res.customer_id] as profDetails">
                    <!-- The medical notes span uses "white-space: pre-line", so there cannot be any newlines -->
                    <!-- before or after the text. -->
                    <span *ngIf="profDetails && profDetails.most_recent_medical_notes"
                          class="medical-notes">{{ profDetails.most_recent_medical_notes }}</span>
                    <span *ngIf="profDetails && !profDetails.most_recent_medical_notes" class="text-muted">
                      None
                    </span>
                  </ng-container>
                </ng-container>
                <span *ngIf="customerNotFound[res.customer_id]"
                    class="text-danger text-nowrap">
                  Customer Not Found
                </span>
              </ng-container>
            </ng-container>
            <span *ngIf="!res.customer_id && res.birthday" class="text-nowrap">
              <a href="#" *ngIf="!loadingUnlinkedReservation[res.reservation_id]"
                 (click)="openReviewUnlinkedReservationModal(res);$event.preventDefault();">
                Not Linked
              </a>
              <span class="text-muted" *ngIf="loadingUnlinkedReservation[res.reservation_id]">
                Loading...
              </span>
            </span>
          </ng-container>

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.capitanProfileField">
            <ng-container *ngIf="res.customer_id">
              <span *ngIf="loadingCustomers" class="text-muted">
                Loading...
              </span>
              <ng-container *ngIf="!loadingCustomers">
                <ng-container *ngIf="!customerNotFound[res.customer_id]" class="text-nowrap">
                  <ng-container *appVar="getCustomerFieldValueForId(column.profile_field_name, res.customer_id) as fieldValue">
                    <span [class.text-nowrap]="fieldValue && (fieldValue.length <= 25)">
                      {{ fieldValue }}
                    </span>
                  </ng-container>
                </ng-container>
                <span *ngIf="customerNotFound[res.customer_id]"
                    class="text-danger text-nowrap">
                  Customer Not Found
                </span>
              </ng-container>
            </ng-container>
            <span *ngIf="!res.customer_id && res.birthday" class="text-nowrap">
              <a href="#" *ngIf="!loadingUnlinkedReservation[res.reservation_id]"
                 (click)="openReviewUnlinkedReservationModal(res);$event.preventDefault();">
                Not Linked
              </a>
              <span class="text-muted" *ngIf="loadingUnlinkedReservation[res.reservation_id]">
                Loading...
              </span>
            </span>
          </ng-container>

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.customCustomerField">
            <ng-container *ngIf="res.customer_id">
              <span *ngIf="loadingCustomers" class="text-muted">
                Loading...
              </span>
              <ng-container *ngIf="!loadingCustomers && customer[res.customer_id]">
                <ng-container *appVar="getCustomerCustomFieldValue(customer[res.customer_id], column.custom_field_name) as fieldValue">
                  <span [class.text-nowrap]="fieldValue && (fieldValue.length <= 25)">
                    {{ fieldValue }}
                  </span>
                </ng-container>
              </ng-container>
            </ng-container>
            <span *ngIf="!res.customer_id && res.birthday" class="text-nowrap">
              <a href="#" *ngIf="!loadingUnlinkedReservation[res.reservation_id]"
                 (click)="openReviewUnlinkedReservationModal(res);$event.preventDefault();">
                Not Linked
              </a>
              <span class="text-muted" *ngIf="loadingUnlinkedReservation[res.reservation_id]">
                Loading...
              </span>
            </span>
          </ng-container>

          <ng-container *ngIf="column.column_type === ScheduledEventsColumnType.attendeeQuestion">
            <ng-container *appVar="getQuestionResponse(res, column.question_name) as response">
              <ng-container *ngIf="Array.isArray(response)">
                <ng-container *ngFor="let responseItem of response; let last = last;">
                  <span [class.text-nowrap]="responseItem.length <= 25">{{ responseItem }}</span>
                  <br *ngIf="!last">
                </ng-container>
              </ng-container>
              <span *ngIf="!Array.isArray(response)" [class.text-nowrap]="response && (response.length <= 25)">
                {{ response }}
              </span>
            </ng-container>
          </ng-container>

        </td>

      </tr>
      <tr *ngIf="filteredReservations().length === 0">
        <td class="reservation-checkbox-column">
          <!-- Create an invisible checkbox for formatting purposes (avoids missing border) -->
          <input type="checkbox" style="visibility: hidden">
        </td>
        <td colspan="99">
          No
          <ng-container *ngIf="search !== ''">matching</ng-container>
          reservations
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSizeEventParticipantsSubList" (change)="pageNumber = 1">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous"
                    [disabled]="pageNumber <= 1"
                    (click)="pageNumber = pageNumber - 1">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link"
                    (click)="pageNumber = pageNumber - 2">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link"
                    (click)="pageNumber = pageNumber - 1">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link"
                    (click)="pageNumber = pageNumber + 1">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link"
                    (click)="pageNumber = pageNumber + 2">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next"
                    [disabled]="pageNumber >= lastPageNumber()"
                    (click)="pageNumber = pageNumber + 1">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
